import React from "react";
import { Icon } from "@iconify/react";

function BasketIcon() {
  return (
    <div>
      <Icon icon="fluent-emoji:basket" width="24" height="24" />
    </div>
  );
}

export default BasketIcon;
